<script>
import {
  FollowerCardElementMixin,
} from "%/dynamic-component-editor/standard-components/follower-card/follower-card-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "FollowerOrgName",
  extends: UrlElement,
  mixins: [FollowerCardElementMixin],
  elementPanelSettings: {
    displayName: "User Name",
    displayIcon: "text-alt",
    elementGroup: "followerElements",
    elementType: "element",
  },
  computed: {
    label() {
      return this.entity.name;
    },
    computedHref() {
      return "#";
    },
  },
};
</script>
